export default "/_next/static/media/favourite@3x.304910046a5255d84fbda2e072be974f.png";